import { cn } from "@/lib/utils";

interface VsHeroVideoProps {
  src: string;
  poster?: string;
  className?: string;
}

/**
 * Looping background video for the hero. Drop-in replacement for
 * `<VsMeshGradient />` inside any positioning context with `overflow-hidden`
 * — sits below the grain overlay so the noise composites on top. Muted,
 * autoplaying, and looped since it's a silent background layer, not a
 * player; `playsInline` keeps it from going fullscreen on iOS Safari.
 *
 * `poster` is a static frame shown before the video paints and whenever
 * autoplay doesn't fire — mobile Safari commonly blocks autoplay (even
 * muted + playsInline) over a poor connection or with Low Data Mode on,
 * which otherwise leaves the header's flat background color showing
 * instead of the intended visual.
 */
export function VsHeroVideo({ src, poster, className }: VsHeroVideoProps) {
  return (
    <video
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 h-full w-full object-cover",
        className
      )}
      src={src}
      poster={poster}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
    />
  );
}
